var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1Monologue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15v39h8v14.56L33.76 54H68V15H8zm56 35H32.37L20 60.12V50h-8V19h52v31zM51 29H18v-4h33v4zm-17 8H18v-4h16v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Monologue.5a0677dc.svg";
export { SvgH1Monologue as ReactComponent };